module.exports = __webpack_public_path__ + "img/top-bg.1c6477bf.png";